<!--

== Base Title

- Props:

    > title
    Título principal

    > subtitle
    Subtitulo, geralmente como um subnível dentro do título.

    > link
    Name de uma rota, para redirecionar quando clicado.


- Slot:
Deve ser utilizado para inserir elementos no lado oposto ao do título (Lado direito), o principal uso é para action buttons.

-->

<template>
  <div>
    <div class="title-box">
      <div class="titles" :class="{ 'is-link': link }">
        <div class="title-section">
          <div @click="backTo()">
            <h1>{{ title }}</h1>
            <h2 v-if="subtitle">
              <span v-if="link" class="back"
                ><i class="fal fa-angle-left"></i
              ></span>
              <span v-else>/ /</span>
              <p class="subtitle">{{ subtitle }}</p>
            </h2>
          </div>
          <div v-if="$slots.tag" class="tag">
            <slot name="tag"></slot>
          </div>
        </div>
        <div v-if="isMobile">
          <p v-if="$slots.default" @click="abMobile = true" class="toggle-ab">
            <i class="fal fa-stream"></i>
          </p>
        </div>
      </div>

      <!-- Title buttons desjtio -->
      <div class="d-flex">
        <div v-if="$slots.info">
          <slot name="info"></slot>
        </div>
        <div
          v-if="!isMobile"
          class="action-buttons"
          :class="{ opened: abMobile }"
        >
          <div ref="infoBox" @click="abMobile = false">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>

    <!-- Title buttons mobile -->
    <div v-if="isMobile && $slots.default">
      <div
        class="tb-fade"
        :class="{ active: abMobile }"
        @click="abMobile = false"
      ></div>
      <div ref="titleBtn" class="title-buttons" :class="{ opened: abMobile }">
        <div>
          <p v-if="isMobile" class="tb-title">{{ title }}</p>

          <div @click="abMobile = false">
            <slot></slot>
            <!-- <base-button text="Cancelar" @click="abMobile = false" class="tb-cancel"/> -->
            <p class="tb-cancel">Fechar</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import BaseButton from '@/components/Button';

export default {
  data() {
    return {
      abMobile: false,
      slotHeight: '',
    };
  },
  props: {
    title: { required: true },
    subtitle: String,
    link: String,
  },
  components: {
    BaseButton,
  },
  methods: {
    backTo() {
      if (this.link) {
        this.$router.push({ name: this.link });
      }
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>
<style scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
  min-height: 58px;
}

.title-box .titles {
  font-family: 'Rubik', sans-serif;
  z-index: 550;
}

.title-section {
  display: flex;
  align-items: baseline;
}

.title-section .tag {
  cursor: default;
  margin-left: 10px;
}
.title-box .back {
  margin-left: 2px;
  margin-right: 8px;
  font-size: 1.6em;
  color: var(--default);
}

.title-box .titles h1 {
  font-size: 2.2em;
  font-weight: 400;
  color: #d9d9d9;
}

.title-box .titles h2 {
  margin-top: 10px;
  font-size: 1.6em;
  font-weight: 300;
  color: #d9d9d9;
  display: flex;
  align-items: center;
  opacity: 0.8;
  font-family: 'Rubik', sans-serif;
}

.title-box .titles h2 .subtitle {
  margin-left: 10px;
}

.is-link {
  cursor: pointer;
}

.action-buttons > div {
  display: flex;
}

/* RESPONSIVO */
@media screen and (max-width: 991px) {
  .title-box {
    margin-bottom: 20px;
    font-size: 9px;
  }

  .title-box .titles h1 {
    font-size: 18px;
    font-weight: 400;
    color: #c9c9c9;
  }

  .title-box .titles {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .title-section {
    display: flex;
    flex-direction: column;
  }

  .title-section .tag {
    margin-left: 0px;
    margin-top: 20px;
  }

  .title-box .back {
    margin-top: 0;
  }

  .title-box .titles .toggle-ab {
    background-color: var(--default);
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 14px;
    border-radius: 5px;
    margin-left: 30px;
    height: 33px;
    width: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title-buttons {
    position: fixed;
    width: 100vw;
    left: 0;
    bottom: -500px;
    z-index: 1910;
    transition: 0.2s linear;
  }

  .title-buttons.opened {
    bottom: 0 !important;
  }

  .title-buttons > div {
    background: var(--background-up);
    padding: 15px;
  }

  .tb-title {
    width: 100%;
    text-align: center;
    padding: 15px 0 35px 0;
    font-size: 14px;
    font-family: 'Rubik', sans-serif;
    color: #a4a4a5;
  }

  .tb-fade {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1900;
    opacity: 0;
    pointer-events: none;
    transition: 0.2s linear;
  }

  .tb-fade.active {
    opacity: 1;
    pointer-events: unset;
  }

  .tb-cancel {
    width: 100%;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 15px;
    font-size: 1.2em;
    cursor: pointer;
    color: #999999a8;
  }
}
</style>
